import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69f12124"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "checkbox"
}
const _hoisted_2 = {
  class: "checkbox__label",
  for: "volltilgungsOption"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_radio = _resolveComponent("radio")!
  const _component_tooltip = _resolveComponent("tooltip")!
  const _component_slider = _resolveComponent("slider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_radio, {
      headline: _ctx.textDauerSollzinsbindung,
      id: "sollzinsbindung",
      options: _ctx.sollzinsbindungenDauer,
      "label-addition": "Jahre",
      "default-option": _ctx.sollzinsbindungValue,
      onValueChanged: _ctx.onSollzinsbindungChanged
    }, null, 8, ["headline", "options", "default-option", "onValueChanged"]),
    (_ctx.volltilgungsoptionVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _withDirectives(_createElementVNode("input", {
            name: "volltilgungsOption",
            type: "checkbox",
            id: "volltilgungsOption",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isVolltilgung) = $event)),
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onVolltilgungChanged && _ctx.onVolltilgungChanged(...args)))
          }, null, 544), [
            [_vModelCheckbox, _ctx.isVolltilgung]
          ]),
          _createElementVNode("label", _hoisted_2, [
            _createTextVNode(_toDisplayString(_ctx.textVolltilgungsoption) + " ", 1),
            _createVNode(_component_tooltip, { text: _ctx.textToolTipVolltilgung }, null, 8, ["text"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.volltilgungsoptionVisible)
      ? _withDirectives((_openBlock(), _createBlock(_component_slider, {
          key: 1,
          id: "rate",
          labelText: _ctx.textSliderRate,
          "slider-values": _ctx.sliderRate,
          "tooltip-text": _ctx.textToolTipRate,
          unit: "€",
          onValueChanged: _ctx.onRateChanged,
          onValueOutOfRange: _ctx.onRateOutOfRange
        }, null, 8, ["labelText", "slider-values", "tooltip-text", "onValueChanged", "onValueOutOfRange"])), [
          [_vShow, !_ctx.isVolltilgung]
        ])
      : _createCommentVNode("", true)
  ], 64))
}